import { useState, useEffect } from "react";
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  format,
  getDayOfYear,
  getWeek,
  addMonths,
} from "date-fns";

export default function useDates({ date }) {
  const [currentMonth, setCurrentMonth] = useState([]);
  const [nextMonth, setNextMonth] = useState([]);

  useEffect(() => {
    const next = addMonths(date, 1);
    const makeDays = (dates, type) => {
      const startDay = startOfMonth(dates);
      const endDay = endOfMonth(dates);
      const interval = eachDayOfInterval({ start: startDay, end: endDay });
      const arr = interval.map((item) => ({
        day: item.getDate(),
        hari: item.getDay(),
        dayOfYear: getDayOfYear(item),
        week: getWeek(item),
        fullDate: format(item, "dd MMMM yyyy"),
        object: item,
      }));
      if (type === "current") {
        setCurrentMonth(arr);
      }
      if (type === "next") {
        setNextMonth(arr);
      }
    };
    makeDays(date, "current");
    makeDays(next, "next");
  }, [date]);

  return { currentMonth, nextMonth };
}

export const useWeeklyDates = ({ date }) => {
  const [week, setWeek] = useState([]);

  useEffect(() => {
    const makeWeeks = () => {
      const startDay = startOfWeek(date);
      const endDay = endOfWeek(date);
      const interval = eachDayOfInterval({ start: startDay, end: endDay });
      const arr = interval.map((item) => ({
        day: item.getDate(),
        hari: item.getDay(),
        dayOfYear: getDayOfYear(item),
        week: getWeek(item),
        fullDate: format(item, "dd MMMM yyyy"),
        object: item,
      }));
      setWeek(arr);
    };
    makeWeeks();
  }, [date]);

  return { week };
};

export const useDailyDate = ({ date }) => {
  const [day, setDay] = useState({});

  useEffect(() => {
    const makeDay = () => {
      const dayObject = {
        day: date.getDate(),
        hari: date.getDay(),
        dayOfYear: getDayOfYear(date),
        week: getWeek(date),
        fullDate: format(date, "dd MMMM yyyy"),
        object: date,
      };
      setDay(dayObject);
    };
    makeDay();
  }, [date]);

  return { day };
};
